import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { CLINIC } from "../../data/content";
import LogoMark from "./LogoMark";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/conditions", label: "Conditions" },
  { to: "/maternal-care", label: "Maternal Care" },
  { to: "/team", label: "Team" },
  { to: "/blog", label: "Blog" },
  { to: "/patient-stories", label: "Stories" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-brand-bg/80 border-b border-black/5">
      <div className="container-wide flex items-center justify-between h-16">
        <Link to="/" data-testid="nav-logo" title="Home" aria-label="Physio Hyve Clinic — Home" className="flex items-center gap-2.5 group">
          <LogoMark size={44} className="transition-transform duration-200 group-hover:scale-105" />
          <span className="hidden sm:inline font-heading font-semibold text-brand-blue leading-none">
            Physio Hyve Clinic
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-6">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm ${isActive ? "text-brand-olive font-medium" : "text-brand-ink2 hover:text-brand-olive"}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href={`tel:${CLINIC.phoneRaw}`} data-testid="nav-call" className="text-sm text-brand-ink2 hover:text-brand-olive flex items-center gap-1.5">
            <Phone size={14}/> {CLINIC.phone}
          </a>
          <Link to="/book" data-testid="nav-book" className="btn-primary text-sm !py-2 !px-4">
            Book Assessment
          </Link>
        </div>

        <button
          className="lg:hidden p-2 text-brand-ink"
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
          aria-label="menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-black/5 bg-white">
          <div className="container-wide py-3 flex flex-col gap-1">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-m-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-3 px-2 text-base ${isActive ? "text-brand-olive font-medium" : "text-brand-ink2"}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link to="/book" onClick={()=>setOpen(false)} className="btn-primary justify-center mt-2" data-testid="nav-m-book">
              Book Assessment
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
